<template>
  <div>
    <div class="intro-y grid grid-cols-12 gap-6 mt-5">
      <div class="col-span-12 md:col-span-6">
        <div class="intro-y flex gap-6">
          <div class="box p-4 py-3">
            <div class="text-gray-500 text-xs">Идэвхтэй зээлийн тоо</div>
            <div class="text-lg font-semibold">{{ positiveBalanceCount }}</div>
          </div>
          <div class="box p-4 py-3">
            <div class="text-gray-500 text-xs">Идэвхтэй зээлийн нийт дүн</div>
            <div class="text-lg font-semibold">{{ positiveBalanceSum.toLocaleString() }}</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6 text-right">
        <div>
          <Button
            @click="downloadCreditDatabase"
            :loading="isDownloadingCreditDatabase"
            type="button"
            class="box text-gray-700 dark:text-gray-300 flex"
          >
            {{ $t('text.downloadCreditDatabase') }}
          </Button>
        </div>
      </div>
    </div>
    <div class="intro-y overflow-auto lg:overflow-visible mt-5">
      <CustomerCreditDatabaseList
        :loading="false"
        :rows="customer.creditDatabases"
        :columns="columnsForCreditDatabase"
        :line-numbers="true"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CUSTOMER_DOWNLOAD_CREDIT_DATABASE } from '@/store/actions/customer';
import Button from '@/components/ui/button/Button';
import CustomerCreditDatabaseList from '@/components/customer/CustomerCreditDatabaseList';

export default {
  props: {
    customer: Object,
  },

  data() {
    return {
      columnsForCreditDatabase: [
        {
          label: 'ID',
          field: 'id',
        },
        {
          label: this.$t('table.th.lender'),
          field: 'clientname',
        },
        {
          label: this.$t('table.th.purpName'),
          field: 'purpName',
        },
        {
          label: this.$t('table.th.advAmount'),
          field: 'advAmount',
        },
        {
          label: this.$t('table.th.advDate'),
          field: 'advDate',
        },
        {
          label: this.$t('table.th.maturityDate'),
          field: 'maturityDate',
        },
        {
          label: this.$t('table.th.balance'),
          field: 'balance',
        },
        {
          label: this.$t('table.th.clsName'),
          field: 'clsName',
        },
        // {
        //   label: this.$t('table.th.loanCode'),
        //   field: 'loanCode',
        // },
        // {
        //   label: this.$t('table.th.loanTypeCode'),
        //   field: 'loanTypeCode',
        // },
        // {
        //   label: this.$t('table.th.loanClassCode'),
        //   field: 'loanClassCode',
        // },
        // {
        //   label: this.$t('table.th.startedDate'),
        //   field: 'startedDate',
        // },
        // {
        //   label: this.$t('table.th.expDate'),
        //   field: 'expDate',
        // },
        // {
        //   label: this.$t('table.th.closedDate'),
        //   field: 'closedDate',
        // },
      ],
    };
  },

  computed: {
    ...mapGetters(['customerDownloadCreditDatabaseStatus']),
    isDownloadingCreditDatabase() {
      return this.customerDownloadCreditDatabaseStatus === 'loading';
    },
    positiveBalanceCount() {
      return (this.customer.creditDatabases || []).filter(r => Number(r.balance) > 0).length;
    },
    positiveBalanceSum() {
      return (this.customer.creditDatabases || [])
        .filter(r => Number(r.balance) > 0)
        .reduce((sum, r) => sum + Number(r.balance), 0);
    },
  },

  methods: {
    async downloadCreditDatabase() {
      const payload = {
        id: this.$route.params.customerId,
      };
      await this.$store.dispatch(CUSTOMER_DOWNLOAD_CREDIT_DATABASE, payload);
      if (this.customerDownloadCreditDatabaseStatus === 'success') {
        this.$toasted.show(this.$t('toast.success'), { type: 'success' });
      }
    },
  },

  components: {
    Button,
    CustomerCreditDatabaseList,
  },
};
</script>
